import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote, ChevronLeft, ChevronRight } from "lucide-react";
import { TESTIMONIALS } from "../data/content";
import { Reveal, Eyebrow } from "./Reveal";

export const Testimonials = () => {
  const [idx, setIdx] = useState(0);
  const [dir, setDir] = useState(1);

  const paginate = (d) => {
    setDir(d);
    setIdx((p) => (p + d + TESTIMONIALS.length) % TESTIMONIALS.length);
  };

  const t = TESTIMONIALS[idx];

  return (
    <section data-testid="testimonials-section" id="testimonials" className="relative py-28 lg:py-40">
      <div className="max-w-5xl mx-auto px-6 lg:px-10">
        <Reveal>
          <div className="flex justify-center">
            <Eyebrow testid="testimonials-eyebrow">Social Proof</Eyebrow>
          </div>
        </Reveal>

        <div className="relative mt-14 min-h-[320px] flex flex-col items-center text-center">
          <Quote className="text-gold/40 mb-8" size={48} />
          <AnimatePresence mode="wait" custom={dir}>
            <motion.blockquote
              key={idx}
              data-testid={`testimonial-${idx}`}
              custom={dir}
              initial={{ opacity: 0, x: dir * 40 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: dir * -40 }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1] }}
              className="max-w-3xl"
            >
              <p className="font-serif font-light italic text-2xl sm:text-3xl lg:text-4xl leading-snug text-cream/90">
                “{t.quote}”
              </p>
              <footer className="mt-10">
                <p className="text-gold font-medium tracking-wide">{t.name}</p>
                <p className="text-cream/45 text-sm mt-1">{t.role}</p>
              </footer>
            </motion.blockquote>
          </AnimatePresence>
        </div>

        <div className="flex items-center justify-center gap-4 mt-12">
          <button
            data-testid="testimonial-prev"
            onClick={() => paginate(-1)}
            className="h-11 w-11 rounded-full border border-white/15 flex items-center justify-center text-cream/70 hover:border-gold hover:text-gold transition-all"
          >
            <ChevronLeft size={18} />
          </button>
          <div className="flex gap-2">
            {TESTIMONIALS.map((_, i) => (
              <button
                key={i}
                onClick={() => { setDir(i > idx ? 1 : -1); setIdx(i); }}
                className={`h-1.5 rounded-full transition-all duration-300 ${i === idx ? "w-8 bg-gold" : "w-2 bg-white/20"}`}
                aria-label={`Testimonial ${i + 1}`}
              />
            ))}
          </div>
          <button
            data-testid="testimonial-next"
            onClick={() => paginate(1)}
            className="h-11 w-11 rounded-full border border-white/15 flex items-center justify-center text-cream/70 hover:border-gold hover:text-gold transition-all"
          >
            <ChevronRight size={18} />
          </button>
        </div>
      </div>
    </section>
  );
};
